import './NewShipment.css'

import { Button, Modal } from 'react-bootstrap'
import React, { useState } from 'react'

import { axiosWithPostUrlEncoded as axios } from 'config/axios.js'
import format from 'date-fns/format'
import { getShipmentSaved } from 'api/ispyb.js'
import parse from 'date-fns/parse'
import qs from 'qs'
import { useSelector } from 'react-redux'
import { withRouter } from 'react-router'

const NewShipment = ({ handleClose, history }) => {
  const sessions = useSelector(state => state.sessions.data)
  const user = useSelector(state => state.user)
  const proposals = useSelector(state => state.proposalInfo.data.map(d => d.proposal).flat())
  const proposalName = proposals[0].code + proposals[0].number
  const [name, setName] = useState('')

  const [sendingLabContactId, setSendingLabContactId] = useState('')
  const [returnLabContactId, setReturnLabContactId] = useState('')

  const [comments, setComments] = useState('')
  const [sessionId, setSessionId] = useState('')

  const labContacts = useSelector(state => state.proposalInfo.data.map(d => d.labcontacts).flat())

  const getLabContactById = id => labContacts.find(contact => contact.labContactId === parseInt(id, 10))

  const handleSave = async event => {
    event.preventDefault()

    const saveData = {
      shippingId: '',
      name,
      status: 'Not Set',
      sendingLabContactId,
      returnLabContactId,
      returnCourier: returnLabContactId,
      courierAccount: getLabContactById(returnLabContactId).courierAccount,
      billingReference: getLabContactById(returnLabContactId).billingReference,
      dewarAvgCustomsValue: getLabContactById(returnLabContactId).dewarAvgCustomsValue,
      dewarAvgTransportValue: getLabContactById(returnLabContactId).dewarAvgTransportValue,
      comments,
      sessionId,
    }

    const { data } = await axios.post(getShipmentSaved(user, proposalName), qs.stringify(saveData))
    handleClose()
    history.push('/prepare/mxshipments/' + data.shippingId)
  }

  return (
    <>
      <Modal show onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Shipment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSave}>
            <div>
              <label className="labelnewshipment" htmlFor="name">
                Name:
              </label>
              <input type="text" onChange={e => setName(e.target.value)} id="name" />
            </div>
            <div>
              <label className="labelnewshipment" htmlFor="session">
                Session:
              </label>
              <select value={sessionId} name="session" onChange={e => setSessionId(e.target.value)} id="session">
                <option value="" disabled>
                  Choose here
                </option>
                {sessions.map(({ sessionId: sId, BLSession_startDate, beamLineName }) => (
                  <option key={sId} value={sId}>
                    {format(parse(BLSession_startDate, 'MMM d, yyyy h:mm:ss aaa', new Date()), 'dd/MM/yyyy')},
                    {beamLineName}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="labelnewshipment" htmlFor="comment">
                Comments:
              </label>
              <textarea onChange={e => setComments(e.target.value)} id="comments" />
            </div>
            <div>
              <label className="labelnewshipment" htmlFor="from">
                From:
              </label>
              <select
                value={sendingLabContactId}
                name="from"
                onChange={e => setSendingLabContactId(e.target.value)}
                id="from"
              >
                <option value="" disabled>
                  Choose here
                </option>
                {labContacts.map(({ labContactId, cardName }) => (
                  <option key={labContactId} value={labContactId}>
                    {cardName}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="labelnewshipment" htmlFor="return_address">
                Return address:
              </label>
              <select
                value={returnLabContactId}
                name="return_address"
                onChange={e => setReturnLabContactId(e.target.value)}
                id="return_address"
              >
                <option value="" disabled>
                  Choose here
                </option>
                {labContacts.map(({ labContactId, cardName }) => (
                  <option key={labContactId} value={labContactId}>
                    {cardName}
                  </option>
                ))}
              </select>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle="primary"
            disabled={!sessionId.length || !sendingLabContactId.length || !returnLabContactId.length || !name.length}
            onClick={handleSave}
          >
            Save
          </Button>

          <Button bsStyle="default" onClick={handleClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default withRouter(NewShipment)
